<template>
  <div>
    <h2>Detail page</h2>
    <p>
        If you are seeing this is due to you navigated from List page.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Detail',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
